import { useTranslation } from 'next-i18next';
import { IUISupplier } from '@bridebook/toolbox/src/types';
import { Box, IColorTypes, colors } from '@bridebook/ui';
import IconPound from '@bridebook/ui/src/components/svg/icon-pound';
import componentStyles from './budget-match-label.style';
import { getSupplierTargetingBudget, isBudgetMatch } from '@bridebook/toolbox/src/isBudgetMatch';

interface IProps {
  supplier: IUISupplier;
  budget?: number | null;
}

const BudgetMatchLabel = ({ budget, supplier }: IProps) => {
  const { t } = useTranslation();

  if (
    !isBudgetMatch(budget, {
      targeting: getSupplierTargetingBudget(supplier),
      tier: supplier.tier,
      type: supplier.type,
      countryCode: supplier.countryCode,
    })
  )
    return null;

  const styles = componentStyles();
  const color = colors.white as keyof IColorTypes;

  return (
    <Box style={styles.wrapper}>
      <IconPound width={10} color={color} style={styles.icon} />
      {t('budgetMatch')}
    </Box>
  );
};

export default BudgetMatchLabel;
